import React from 'react';
import {IProduct} from 'data/interfaces/products';
import {IOrder} from 'data/interfaces/orders';
import ConclusionCard from '../../../conclusionCard';
import TimeAndStatusConclusion from '../../../conclusionCard/components/timeAndStatusConclusion';


interface ISaleConclusionProps {
  product?: IProduct;
  order?: IOrder;
  isProductOwner: boolean;
  isOrderOwner: boolean;

  originalPrice?: number;
  salePrice?: number;
  currency?: number;

  details?: any;
  aboveComponent?: any;
  loadProduct?: () => Promise<any>;
}

const SaleConclusion = (props: ISaleConclusionProps) => {
  return (
    <ConclusionCard
      className={'saleConclusion'}
      salePrice={props.salePrice}
      originalPrice={props.originalPrice}
      currency={props.currency}
      showTopPriceConclusion={false}
      showBottomPriceConclusion={true}
      hideDiscount={!props.isOrderOwner}

      aboveComponent={props.aboveComponent}

      top={
        props.details
      }
      bottomTitle={
        <span style={{color: "#323232"}}>
           סיכום מכירה
        </span>
      }
      bottom={
        <TimeAndStatusConclusion {...props}/>
      }
    />
  )
    ;
};

SaleConclusion.defaultProps = {
  product: {},
  order: {},
};

export default React.memo(SaleConclusion);
